export default __webpack_public_path__ + "static/cruiselines-vrc-places-3-6e77bd0a99faee35a02a300018fcb284.jpg";